import ApplicationError from "@insightfulscience/smart-react/ApplicationError";

export const ERROR_ACCOUNT_REVIEW_REQUIRED = "EACCOUNT_REVIEW_REQUIRED";

export const isAccountReviewRequiredError = (e?: unknown) =>
	e === `errors.${ERROR_ACCOUNT_REVIEW_REQUIRED}` ||
	e === ERROR_ACCOUNT_REVIEW_REQUIRED;

export const createAccountReviewRequiredError = () =>
	new ApplicationError(null, 403, ApplicationError.defaultMessage[403], {
		errorCode: ERROR_ACCOUNT_REVIEW_REQUIRED,
	});

export const throwIfAccountReviewRequiredError = (errorCode?: unknown) => {
	const isReviewRequiredError = Array.isArray(errorCode)
		? errorCode.some(isAccountReviewRequiredError)
		: isAccountReviewRequiredError(errorCode);
	if (isReviewRequiredError) {
		throw createAccountReviewRequiredError();
	}
};
